var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pill-list"},_vm._l((_vm.items),function(item,index){return _c('div',{key:`${index}-${item.label}`,class:_vm.getItemClassName(item),attrs:{"title":item.label},on:{"click":() => _vm.action(item)}},[_c('p',{staticClass:"pill-list-text"},[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }